// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__HH5nV","no_border":"menu_no_border__WKhWp","wrapper":"menu_wrapper__ebSCw","arrow":"menu_arrow__aYhG2"};